export class QuantitySelector {
  /**
   * Init needed events for quantity selector HTML elements from formular
   * @param {Node} prmQuantitySelector
   */
  constructor(prmQuantitySelector) {
    this.quantitySelector = prmQuantitySelector;
    this.min = parseFloat(this.quantitySelector.getAttribute('min') || this.quantitySelector.dataset.min);
    this.max = parseFloat(this.quantitySelector.getAttribute('max') || this.quantitySelector.dataset.max);
    this.step = parseFloat(this.quantitySelector.getAttribute('data-step'));
    this.buttons = this.quantitySelector.parentElement.querySelectorAll('button');
    _quantitySelectorEvent.call(this, this.quantitySelector);
  }
}

/**
 * Init event on input and element sibling near to it (buttons)
 */
function _quantitySelectorEvent() {
  _disableButtons.call(this);
  this.quantitySelector.addEventListener('blur', () => {
    const value = _getNumberValue.call(this);
    this.quantitySelector.value = Math.max(value, this.min);
    this.quantitySelector.value = Math.min(value, this.max);
    _disableButtons.call(this);
  });
  this.buttons[0].addEventListener('click', event => {
    event.preventDefault();
    _decrement.call(this, this.step);
    _disableButtons.call(this);
  });
  this.buttons[1].addEventListener('click', event => {
    event.preventDefault();
    _increment.call(this, this.step);
    _disableButtons.call(this);
  });

  // Keyboard interaction 
  //(https://www.w3.org/TR/wai-aria-practices-1.1/#spinbutton)
  this.quantitySelector.addEventListener('keydown', event => {
    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowLeft':
        event.preventDefault();
        _decrement.call(this, this.step);
        _disableButtons.call(this);
        break;
      case 'ArrowUp':
      case 'ArrowRight':
        event.preventDefault();
        _increment.call(this, this.step);
        _disableButtons.call(this);
        break;
      case 'PageUp':
        event.preventDefault();
        _increment.call(this, this.step * 5);
        _disableButtons.call(this);
        break;
      case 'PageDown':
        event.preventDefault();
        _decrement.call(this, this.step * 5);
        _disableButtons.call(this);
        break;
      case 'Home':
        event.preventDefault();
        _decrement.call(this, this.max);
        _disableButtons.call(this);
        break;
      case 'End':
        event.preventDefault();
        _increment.call(this, this.max);
        _disableButtons.call(this);
        break;
    }
  });
}

/**
 * Decrement the quantity by a specific amount
 */
function _decrement(amount) {
  const value = _getNumberValue.call(this);
  this.quantitySelector.value = Math.max(value - amount, this.min);
}

/**
 * Increment the quantity by a specific amount
 */
function _increment(amount) {
  const value = _getNumberValue.call(this);
  this.quantitySelector.value = Math.min(value + amount, this.max);
}

/**
 * Disabled buttons to step up or step down quantitySelector's value
 */
function _disableButtons() {
  const value = _getNumberValue.call(this);
  switch (value) {
    case this.min:
      this.buttons[0].disabled = true;
      this.buttons[1].disabled = false;
      break;
    case this.max:
      this.buttons[0].disabled = false;
      this.buttons[1].disabled = true;
      break;
    default:
      this.buttons[0].disabled = false;
      this.buttons[1].disabled = false;
  }
}

/**
 * Return value with comma replace by point.
 * @returns {String}
 */
function _acceptComma(prmValue) {
  return prmValue.replace(/,/g, '.');
}

/**
 * Return the value of quantitySelector element passed as parameter
 * @returns {BigInt}
 */
function _getNumberValue() {
  return this.quantitySelector.value === '0' ? 0 : parseFloat(_acceptComma(this.quantitySelector.value)) || 1;
}